import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import "../../styles/base/baseline.css";
import "../../styles/pages/services.css";

import "../../styles/module/collaborate.css";
import "../../styles/module/carousel.css";

import WhyUs from "../module/Why-Us";
import WebCust from "../module/WebCust-Slider";
import Collaborate from "../module/Collaborate";
import FAQs from "../module/FAQs";
import Clients from "../module/Clients";

import bg2 from "../../assets/images/img/bg-2.webp";
// import bg3 from "../../assets/images/img/bg-3.svg";
import arrow from "../../assets/images/img/downarrow.webp";

export default function WebsiteCustomization() {
  useScrollReveal("slide-from-left");
  useScrollReveal("slide-from-right");
  useScrollReveal("drop-from-top");
  return (
    <>
      <div className="main-wrapper">
        <img
          alt="scrollDown"
          src={bg2}
          className=" landing__image-background-2 image-background slide-from-left"
        />
        <div
          className="rotated-text"
          onClick={() => (window.location.href = "#scroll")}
        >
          <img src={arrow} alt="downarrow" className="" />
          <h4>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}> scroll down</font>
            </font>
          </h4>
        </div>
        <div className="section section__oferta">
          {/* <img
            className="landing__image-background-1 image-background slide-from-right"
            src={bg3}
            alt="container background"
          /> */}
          <div className="container oferta">
            <h5 className="drop-from-top" id="scroll">
              <font style={{ verticalAlign: "inherit" }}>
                <font style={{ verticalAlign: "inherit" }}>service</font>
              </font>
            </h5>
            <div className="title drop-from-top">
              <h2 style={{ marginBottom: "30px" }}>
                Website Customization Built Around Your Vision
              </h2>
            </div>
            <div className="description container__text">
              <p className="slide-from-left">
                We transform standard websites into tailored digital experiences
                that align with your brand, business goals, and user
                expectations. From adjusting layouts and navigation to adding
                custom features or third-party tools, every element is refined
                to match your specific needs.
              </p>
              <p className="slide-from-right">
                Our focus is on functionality, design consistency, and
                scalability—ensuring your site not only looks the part but works
                seamlessly across all devices. Whether you’re refreshing a
                current site or building on an existing platform, we deliver
                custom solutions that elevate your online presence and user
                experience.
              </p>
            </div>
          </div>
        </div>
        <WhyUs hideBackgroundImage={true} />
        <WebCust />
        <Collaborate />
        <FAQs />

        <Clients />
      </div>
    </>
  );
}
